import React, { useState, useEffect, useRef } from 'react';
import {object, func, bool, string} from 'prop-types';

import {CloneObject} from '../../../utils/helpers';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import {VALIDATION_MESSAGE} from '../../../consts/validationMessage';
import {useFormErrors} from '../../hooks/useFormErrors';
import {OnKeyPress_validInteger, isValidNumber} from '../../../utils/validator';
import InputLista from '../../common/InputLista';
import DireccionForm from '../DireccionForm';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import InputNumber from '../../common/InputNumber';
import Modal from '../../common/Modal';
import {TIPS} from "../../../consts/tips";
import {Accordion, FormError, FormLabel} from '../../common';

const LadoTerrenoModal = (props) => {

    const entityInit = {
        id: 0,
        idInmueble: 0,
        idTipoLado: 0,
        numero: '',
        metros: 0,
        reduccion: 0,
        direccion: {
            id: 0,
            entidad: "LadoTerreno",
            idEntidad: 0,
            idTipoGeoreferencia: 0,
            idPais: 0,
            idProvincia: 0,
            idLocalidad: 0,
            idZonaGeoreferencia: 0,
            codigoPostal: "",
            calle: "",
            entreCalle1: "",
            entreCalle2: "",
            altura: "",
            piso: "",
            dpto: "",
            referencia: "",
            longitud: 0,
            latitud: 0,
            origen: ""
        }
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
    });

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity};
        });
        formSet({
            idTipoLado: props.data.entity.idTipoLado,
            numero: props.data.entity.numero,
            metros: props.data.entity.metros,
            reduccion: props.data.entity.reduccion
        });
    }
    useEffect(mount, [props.data.entity]);


    const [formValues, formHandle, , formSet] = useForm({
        idTipoLado: 0,
        numero: '',
        metros: 0,
        reduccion: 0
    });

    const direccionFormRef = useRef()

    const CAMPOS_LADO = ['idTipoLado', 'numero'];
    const [ladoOpen, setLadoOpen] = useState(true);
    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors);

    //handles
    const handleClickAceptar = () => {
        const errors = { ...getErrors(), ...getFormatErrors() };
        const direccionValida = isDireccionValid();
        if (CAMPOS_LADO.some(campo => errors[campo]) || !direccionValida) setLadoOpen(true);
        if (!validate() || !direccionValida) return;

        let row = CloneObject(state.entity);
        row.idTipoLado = parseInt(formValues.idTipoLado);
        row.numero = parseInt(formValues.numero);
        row.metros = formValues.metros;
        row.reduccion = formValues.reduccion;

        row.direccion = direccionFormRef.current.getDataDireccion()

        props.onConfirm(row);
    };

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.idTipoLado <= 0) errors.idTipoLado = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.numero === '') errors.numero = VALIDATION_MESSAGE.REQUIRED;

        return errors;
    }

    function getFormatErrors() {

        const errors = {};
        if (props.disabled) return errors;

        if (formValues.numero !== '' && !isValidNumber(formValues.numero, true)) errors.numero = 'Ingresá un número mayor a cero';

        return errors;
    }

    function isDireccionValid() {

        const data = direccionFormRef.current.getDataDireccion()
        if (
            formValues.idTipoLado === 40 ||
            data.altura ||
            data.calle ||
            data.codigoPostal ||
            data.dpto ||
            data.entreCalle1 ||
            data.entreCalle2 ||
            data.idPais ||
            data.idProvincia ||
            data.piso
        ) {
            const isValidDireccion = direccionFormRef.current.isValidDireccion()
            if (!isValidDireccion.result) {
                if (isValidDireccion.message) ShowToastMessage(ALERT_TYPE.ALERT_WARNING, isValidDireccion.message);
                return false;
            }
        }

        return true;
    }

    return (
        <>

            <Modal
                size="lg"
                title={`Lado del terreno: ${(state.entity.id > 0) ? state.entity.numero : "Nuevo"}`}
                tipName={TIPS.NAME.MODALS.LADO_TERRENO_MODAL}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">

                                <div className="mb-3 col-12">
                                    <Accordion title="Lado del terreno" keepMounted={true} open={ladoOpen} onToggle={setLadoOpen}>
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-6 col-lg-3">
                                                <FormLabel htmlFor="idTipoLado" required>Tipo</FormLabel>
                                                <InputLista
                                                    name="idTipoLado"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idTipoLado') ? 'is-invalid' : ''}`}
                                                    value={formValues.idTipoLado}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    lista="TipoLado"
                                                />
                                                <FormError message={errorOf('idTipoLado')} />
                                            </div>
                                            <div className="mb-3 col-6 col-lg-3">
                                                <FormLabel htmlFor="numero" required>Número</FormLabel>
                                                <input
                                                    name="numero"
                                                    type="text"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('numero') ? 'is-invalid' : ''}`}
                                                    value={formValues.numero}
                                                    onChange={formHandle}
                                                    onKeyPress={OnKeyPress_validInteger}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('numero')} />
                                            </div>
                                            <div className="mb-3 col-6 col-lg-3">
                                                <label htmlFor="metros" className="form-label">Metros</label>
                                                <InputNumber
                                                    name="metros"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.metros}
                                                    precision={2}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError />
                                            </div>
                                            <div className="mb-3 col-6 col-lg-3">
                                                <label htmlFor="reduccion" className="form-label">Reducción</label>
                                                <InputNumber
                                                    name="reduccion"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.reduccion}
                                                    precision={2}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError />
                                            </div>

                                            <div className="mb-3 col-12">
                                                <DireccionForm
                                                    ref={direccionFormRef}
                                                    data={{
                                                        entity: state.entity.direccion
                                                    }}
                                                    disabled={props.disabled}
                                                    initFormEdit={(state.entity.direccion.id === 0 && state.entity.direccion.latitud === 0 && state.entity.direccion.longitud === 0)}
                                                />
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Información adicional ">
                                        <DataTaggerFormRedux
                                            title="Información adicional de Lado del Terreno"
                                            processKey={props.processKey}
                                            entidad="LadoTerreno"
                                            idEntidad={state.entity.id}
                                            disabled={props.disabled}
                                        />
                                    </Accordion>
                                </div>
                            </div>
                )}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
                </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
                )}
                footerClassName={props.disabled ? 'f-align' : ''}
            />

        </>
    );
}

LadoTerrenoModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

LadoTerrenoModal.defaultProps = {
    disabled: false
};

export default LadoTerrenoModal;